export const supportedLocales = ["et", "en", "ru"] as const;

export type SupportedLocale = (typeof supportedLocales)[number];

export const defaultLocale: SupportedLocale = "et";

export function isSupportedLocale(value: string): value is SupportedLocale {
  return supportedLocales.includes(value as SupportedLocale);
}

export function getLocaleFromPath(pathname: string): SupportedLocale {
  const firstSegment = pathname.split("/").filter(Boolean)[0] ?? "";
  return isSupportedLocale(firstSegment) ? firstSegment : defaultLocale;
}

export function getLocalePath(locale: SupportedLocale): string {
  return `/${locale}/`;
}

export function isHomePath(pathname: string): boolean {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return normalized === "/" || supportedLocales.some((locale) => normalized === `/${locale}`);
}
